import {
  AuditOutlined,
  BarChartOutlined,
  CarOutlined,
  FileSearchOutlined,
  MessageOutlined,
  SolutionOutlined,
  TeamOutlined
} from '@/media/antd-icons';
import type { TModuleCode } from '@/shared/routes';

/** Иконка раздела в меню и таб-баре по коду модуля. */
export const MODULE_ICONS: Record<
  TModuleCode,
  React.FC<React.SVGProps<SVGSVGElement>>
> = {
  'autocredit-requests': SolutionOutlined,
  contracts: AuditOutlined,
  'collateral-property': CarOutlined,
  clients: TeamOutlined,
  'client-contract-appeals': MessageOutlined,
  assessments: FileSearchOutlined,
  reports: BarChartOutlined
};

/** Ключ названия раздела в меню и таб-баре по коду модуля — совпадает с заголовком раздела. */
export const MODULE_TITLES: Record<TModuleCode, string> = {
  'autocredit-requests': 'leasingScoring.title',
  contracts: 'contracts.title',
  'collateral-property': 'leasedProperty.title',
  clients: 'clients.title',
  'client-contract-appeals': 'appeals.title',
  assessments: 'assessments.title',
  reports: 'reports.title'
};

/** Разделы, которые всегда стоят в нижнем таб-баре (если открыты сотруднику). */
export const TAB_BAR_PINNED_MODULES: TModuleCode[] = [
  'autocredit-requests',
  'contracts'
];

/**
 * Третий пункт таб-бара — последний открытый раздел вне закреплённых;
 * до первого перехода — первый доступный из этих.
 */
export const TAB_BAR_DEFAULT_MODULES: TModuleCode[] = ['clients', 'reports'];

/** Ширина drawer с разделами; на узком экране — не шире окна. */
export const NAV_DRAWER_WIDTH = 300;
